import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider";
import axios from "axios";
import Swal from "sweetalert2";

const PrivateRoutes = ({ children }) => {
  const { user, loading, userInfo, logOut } = useContext(AuthContext); // Assuming you have a logout function in AuthContext
  const [isLoading, setIsLoading] = useState(true);
  const [userHasCourse, setuserHasCourse] = useState(false);
  const location = useLocation();
  const fullPath = `${location.pathname}${location.search}`;
  const [taskTypeForAPI, setTaskTypeForAPI] = useState("");
  const [taskData, setTaskData] = useState();
  const [accessChecked, setAccessChecked] = useState(false);
  // Split the fullPath before the '?' to isolate the path part
  const [path, queryString] = fullPath.split("?");

  // Extract the ID from the path (the part after '/taskDetails/')
  const pathParts = path.split("/");
  const id = pathParts[2]; // This will give you '6639e0a8e7854998c458c4e3'

  // Extract the taskType from the query string
  const searchParams = new URLSearchParams(queryString);
  const taskType = searchParams.get("taskType"); // This will give you 'Schedule'

  // console.log(id); // Output: 6639e0a8e7854998c458c4e3
  // console.log(taskType); // Output: Schedule

  // Map taskType to API-friendly values
  useEffect(() => {
    if (taskType === "Assignment") setTaskTypeForAPI("assignments");
    else if (taskType === "Classes") setTaskTypeForAPI("classes");
    else if (taskType === "Reading") setTaskTypeForAPI("readings");
    else if (taskType === "Quiz") setTaskTypeForAPI("quizes");
    else if (taskType === "Live Test") setTaskTypeForAPI("liveTests");
    else if (taskType === "Video") setTaskTypeForAPI("videos");
    else if (taskType === "Audio") setTaskTypeForAPI("audios");
    else if (taskType === "Files") setTaskTypeForAPI("files");
    else if (taskType === "Schedule") setTaskTypeForAPI("schedule");
  }, [taskType]);

  // Fetch task data
  useEffect(() => {
    if (taskTypeForAPI && id) {
      axios
        .get(
          `${process.env.REACT_APP_SERVERLESS_API}/api/v2/tasks/taskType/${taskTypeForAPI}/taskId/${id}`
        )
        .then((response) => {
          setTaskData(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
        });
    }
  }, [taskTypeForAPI, id]);
  useEffect(() => {
    if (userInfo?.role === "user" && taskData) {
      const userCourse = userInfo?.courses?.find(
        (course) => course?.courseId === taskData?.courseId
      );
      if (userCourse) {
        setuserHasCourse(true);
      }
      // Ensure `accessChecked` is only true once `userHasCourse` is evaluated
      setAccessChecked(true);
    } else if (userInfo && taskData) {
      // If user is not a standard user, mark access as checked for roles like 'admin'
      setAccessChecked(true);
    }
  }, [userInfo, taskData]);
  
// Adjusted condition to wait until access has been checked
const showAccessDeniedPopup = async () => {
  if (!userHasCourse) {
    const result = await Swal.fire({
      title: "Access Denied",
      text: "You do not have access to this task. Please login again.",
      icon: "error",
      confirmButtonText: "Logout",
    });

    if (result.isConfirmed) {
      try {
        await logOut();
        Navigate("/login");
      } catch (error) {
        console.error(error);
      }
    }
  }
};
useEffect(() => {
  if (accessChecked && !userHasCourse && userInfo?.role === "user") {
    showAccessDeniedPopup();
  }
}, [accessChecked, userHasCourse, userInfo]);
  // console.log(taskTypeForAPI);
  // console.log(taskData);

  // Loading state
  if (loading || isLoading) {
    return (
      <div className="text-center">
        <div role="status">
          <svg
            aria-hidden="true"
            className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // Function to show SweetAlert with logout option
  // Function to show SweetAlert with logout option using async/await



  // Check if user is authenticated and their courseId matches taskData.courseId
  if (user && userInfo) {
    console.log(userHasCourse);
    if (userHasCourse || userInfo?.role === 'admin' || userInfo?.role === 'execution mentor' || userInfo?.role === 'expert mentor') {
      return children;
    } else {
      // showAccessDeniedPopup(); // Trigger SweetAlert when access is denied
      return null; // Prevent further rendering
    }
  }

  return <Navigate to="/login" state={{ from: fullPath }} replace></Navigate>;
};

export default PrivateRoutes;
